import { CASE_STUDIES, CASE_STUDY_CONFIG } from '../constants/caseStudies';

const CaseStudy = ({ caseStudy, index }) => {
  const isEven = index % 2 === 0;

  return (
    <article className={`cs-item ${isEven ? 'cs-item--normal' : 'cs-item--reverse'}`}>

      {/* SVG / Image — large side */}
      <div className="cs-visual">
        <div className="cs-visual-inner">
          <img
            src={caseStudy.image}
            alt={caseStudy.title}
            className="cs-img"
            loading="lazy"
          />
        </div>
      </div>

      {/* Content side */}
      <div className="cs-content">
        <span className="cs-category">{caseStudy.category}</span>

        <h3 className="cs-title">{caseStudy.title}</h3>
        <p className="cs-subtitle">{caseStudy.subtitle}</p>
        <p className="cs-description">{caseStudy.description}</p>

        {/* Challenge → Solution → Results */}
        <div className="cs-csr">
          <div className="cs-csr-block">
            <span className="cs-csr-label">Challenge</span>
            <p className="cs-csr-text">{caseStudy.challenge}</p>
          </div>
          <div className="cs-csr-block">
            <span className="cs-csr-label">Solution</span>
            <p className="cs-csr-text">{caseStudy.solution}</p>
          </div>
          <div className="cs-csr-block">
            <span className="cs-csr-label">Results</span>
            <ul className="cs-results">
              {caseStudy.results.map((r, i) => (
                <li key={i}>{r}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* Tech stack */}
        <div className="cs-tech">
          {caseStudy.technologies.map((t, i) => (
            <span key={i} className="cs-tech-tag">{t}</span>
          ))}
        </div>

        {/* Links */}
        {(caseStudy.docsUrl || caseStudy.liveUrl || caseStudy.demoUrl || caseStudy.contactUrl) && (
          <div className="cs-links">
            {caseStudy.docsUrl && (
              <a href={caseStudy.docsUrl} target="_blank" rel="noopener noreferrer" className="cs-link cs-link--docs">
                Documentation ↗
              </a>
            )}
            {caseStudy.liveUrl && (
              <a href={caseStudy.liveUrl} target="_blank" rel="noopener noreferrer" className="cs-link cs-link--live">
                {caseStudy.liveLabel || 'View Live'} ↗
              </a>
            )}
            {caseStudy.demoUrl && (
              <a href={caseStudy.demoUrl} target="_blank" rel="noopener noreferrer" className="cs-link cs-link--demo">
                {caseStudy.demoLabel || 'Schedule a Demo'} →
              </a>
            )}
            {caseStudy.contactUrl && (
              <a href={caseStudy.contactUrl} className="cs-link cs-link--contact">
                {caseStudy.contactLabel || 'Get in Touch'} →
              </a>
            )}
          </div>
        )}
      </div>

    </article>
  );
};

const CaseStudies = () => (
  <section className="cs-section" id="case-studies">
    <div className="cs-header">
      <h2 className="section-title">
        {CASE_STUDY_CONFIG.sectionTitle.split(' ')[0]}{' '}
        <span className="gradient-text">{CASE_STUDY_CONFIG.sectionTitle.split(' ')[1]}</span>
      </h2>
      <p className="section-subtitle">{CASE_STUDY_CONFIG.sectionSubtitle}</p>
    </div>

    <div className="cs-list">
      {CASE_STUDIES.map((cs, i) => (
        <CaseStudy key={cs.id} caseStudy={cs} index={i} />
      ))}
    </div>
  </section>
);

export default CaseStudies;
